import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

/**
 * Requires manage_events for the current context (coach, manager, admin, or owner).
 */
export const eventsManageGuard: CanActivateFn = async (): Promise<boolean> => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  const can = await permissions.canManageEvents();
  if (!can) {
    await router.navigate(['/schedule']);
    return false;
  }
  return true;
};
